import React from "react";
import { Link, useNavigate } from "react-router-dom";
import success from "../assets/img/icons/success.png";
import loginVideo from "../assets/video/login.mp4";
import { additional_url } from "../config/url";

const SignupSuccess = () => {
  const navigate = useNavigate();
  return (
    // <main>
    //   <div className="header-margin"></div>

    //   <section className="">
    //     <div className="container-fluid">
    //       <div className="row">
    //         <div className="col-xl-6 col-lg-6 col-md-6 px-0 lg:d-none">
    //           <div className="video-container">
    //             <video autoPlay loop muted>
    //               <source src={loginVideo} type="video/mp4" />
    //             </video>
    //           </div>
    //         </div>
    //         <div className="col-xl-6 col-lg-6 col-md-6 px-80 py-50 lg:px-15 lg:py-20">
    <div className="px-20 py-50 sm:px-20 sm:py-20 bg-white bg-shadow rounded-16">
      <div className="row y-gap-20">
        <div className="col-12 text-center">
          {/* <img
                      src="img/general/logo-dark.png"
                      alt="logo icon"
                      width="150"
                    /> */}
          <p className="text-25 fw-700 text-primary lh-13">
            Welcome to Fitizen India!
          </p>
          <p className="text-16 fw-500">Your Account is active now</p>
        </div>
        <div className="col-12 mt-20 d-flex justify-center">
          <img src={success} alt="success image" />
        </div>
      </div>
      <div className="row y-gap-20 pt-20">
        <div className="col-6">
          <p className="text-12 fw-500 text-center lh-14">
            <b>Almost There!</b>
            {/* <br />
            Completing your profile unlocks faster bookings */}
          </p>
        </div>
        <div className="col-6">
          <p className="text-12 fw-500 text-center lh-14">
            <b>Awesome!</b>
            {/* <br />
            You're All set to Explore Events */}
          </p>
        </div>
      </div>
      <div className="row y-gap-20">
        <div className="col-6">
          <div className="d-flex items-center justify-center">
            <Link
              // to={`${additional_url}dashboard/profile`}
              onClick={() => {
                localStorage.setItem("dashboardTab", "profile");
                navigate("/dashboard/profile", { replace: true });
              }}
              className="button col-12 border-primary text-primary -primary-1 py-15 px-20 rounded-100 mt-10 text-14 justify-center"
            >
              Complete Your Profile
            </Link>
          </div>
        </div>
        <div className="col-6">
          <div className="d-flex items-center justify-center">
            <Link
              to={`${additional_url}`}
              className="button col-12 border-primary text-primary -primary-1 py-15 px-20 rounded-100 mt-10 text-14 justify-center"
            >
              Explore Events
            </Link>
          </div>
        </div>
      </div>
    </div>
    //         </div>
    //       </div>
    //     </div>
    //   </section>
    // </main>
  );
};

export default SignupSuccess;
